import { StyleSheet, Platform, Dimensions } from 'react-native'

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    width: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '100%' : 192,
    // height: 118,
    borderRadius: 6.2,
  },
  cardNumber: {
    fontSize: 16,
    marginTop: 18,
  },
  addCard: (theme, isValidTopupNumber) => ({
    borderWidth: 1,
    borderColor: isValidTopupNumber ? theme.colors.activeTabColor : '#CCCCCC',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16
  }),
  addCardText: {
    marginTop: 5,
    lineHeight: 16.6,
    marginRight: 8,
    fontSize: 16.6,
    color: Colors.vfRed,
  },
  addCardText: (isValidTopupNumber) => {
    return ({
      marginTop: 5,
      lineHeight: 16.6,
      marginRight: 8,
      fontSize: 16.6,
      color: isValidTopupNumber ? Colors.vfRed : '#CCCCCC',
    })
  },
});
